import {
  createApiRef,
  DiscoveryApi,
  FetchApi,
} from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import { UpcomingEventsResponse } from './types';

/** Reads upcoming DevHub events from the `devhub-events` backend. */
export interface DevHubEventsApi {
  getUpcoming(options?: { limit?: number }): Promise<UpcomingEventsResponse>;
}

export const devhubEventsApiRef = createApiRef<DevHubEventsApi>({
  id: 'plugin.devhub-events.service',
});

export class DevHubEventsClient implements DevHubEventsApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getUpcoming(options: { limit?: number } = {}): Promise<UpcomingEventsResponse> {
    const baseUrl = await this.discoveryApi.getBaseUrl('devhub-events');
    const query =
      options.limit !== undefined ? `?limit=${encodeURIComponent(String(options.limit))}` : '';
    const response = await this.fetchApi.fetch(`${baseUrl}/upcoming${query}`);
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return (await response.json()) as UpcomingEventsResponse;
  }
}
